module.exports = "/images/Iterate.svg";